import { Component } from '@angular/core';
import { LogisticsService } from '../../../../services/logistics.service';
import { OrderLogisticsInfo } from 'src/app/model/logistics/order';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationToastService } from '../../../../services/notification-toast.service';

@Component({
  selector: 'app-tool-medical-order-transit-control',
  templateUrl: './tool-medical-order-transit-control.component.html',
})
export class ToolMedicalOrderTransitControlComponent {

  items: OrderLogisticsInfo[] = [];
  form: FormGroup;
  loading: boolean;
  isSubmited: boolean;

  constructor(private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , private logisticsService: LogisticsService) {
    this.form = this.formBuilder.group({
      protocol: ['', Validators.required],
    });
  }

  get f() { return this.form.controls; }

  async findOrderLogisticsInfo()  {
    try {
      if (this.form.valid) {
        this.isSubmited = true;
        this.loading = true;
        this.items = await this.logisticsService
        .getMedicalOrderLogisticInfo(this.form.value.protocol);
      }
    } catch (err)  {
      this.notificationToastService.error(JSON.stringify(err.error), 'Estado orden tránsito');
    } finally {
      this.loading = false;
    }
  }
}
